// extracted by mini-css-extract-plugin
module.exports = {"totalScore":"totalScore_totalScore__O7gGZ","primaryNumber":"totalScore_primaryNumber__2EaQ7"};